export default {
  GET_ITEMS(state) {
    return state.artisans
  },

  GET_ITEM(state, id) {
    return state.artisans.find(item => item.id == id)
  },
}
